<template>
    <v-card>
        <v-card-title>
            <span class="display-1">Histórico modificaciones ensayos</span>
            <v-spacer></v-spacer>
        </v-card-title>
        <v-data-table :items="items" :headers="headers" :loading="loading" :expanded.sync="expanded" show-expand>

            <template v-slot:[`item.created_at`]="{ item }">
                {{fechaFormateada(item.created_at)}}
            </template>

            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <v-data-table :headers="headers_ant" :items="[item]" hide-default-footer></v-data-table>
                </td>
            </template>

        </v-data-table>
    </v-card>
</template>

<script>
import moment from 'moment-timezone';
import { mapActions } from 'vuex';
export default {
    data() {
        return {
            datos: [],
            items: [],
            headers: [
                // {text: "ID", align: 'center', value: 'id'},
                {text: "Nombre Ciclo", align: 'center', value: 'nombre_ciclo'},
                {text: "Realizado por", align: 'center', value: 'name'},
                {text: "Fecha Realizacion", align: 'center', value: 'created_at'},
                // {text: "ID usuario", align: 'center', value: 'id_usuario'},
                {text: "ID ensayo", align: 'center', value: 'id_ensayo'},
                {text: "Trabajador", align: 'center', value: 'worker'},
                {text: "Lote MP", align: 'center', value: 'lote_mp'},
                {text: "Lote Bolson", align: 'center', value: 'lote_bolson'},
                {text: "Lote Membrana higenizada", align: 'center', value: 'lote_mem_higenizada'},
                // {text: "Cuerpos extraños", value: 'cuerpos_extr'},
                {text: "Kg membrana T2", align: 'center', value: 'kg_membrana_t2'},
            ],
            loading: true,
            ids: [],
            expanded: [],
            headers_ant: [
                {text: "Lote MP ANTERIOR", align: 'center', value: 'lote_mp_ant'},
                {text: "Lote Bolson ANTERIOR", align: 'center', value: 'lote_bolson_ant'},
                {text: "Lote Membrana higenizada ANTERIOR", align: 'center', value: 'lote_mem_higenizada_ant'},
                {text: "Kg membrana T2 ANTERIOR", align: 'center', value: 'kg_membrana_t2_ant'},
            ],
        }
    },
    methods: {
        ...mapActions(['getData']),
        fechaFormateada(fecha){
            return moment(fecha).format('YYYY-MM-DD HH:mm:ss')
        },
        async getModificaciones() {
            this.loading = true;
            const payload = {
                path: 'ciclos/get-modificaciones-ensayos',
                params: {}
            };
            
            const res = await this.getData(payload);
            const salida = res.results;

            // Extraer IDs únicos para filtrar en el backend si fuera posible, 
            // o para el procesamiento local.
            this.ids = salida.map(element => `${element.id_ensayo}`);

            // Esperamos los datos de ensayos
            await this.getDatosEnsayos();

            // OPTIMIZACIÓN: Crear un Mapa para búsqueda instantánea O(1)
            const ensayosMap = new Map();
            this.datos.forEach(d => {
                ensayosMap.set(d.id_ensayo, d.nombre);
            });

            // Mapear los items una sola vez
            this.items = salida.map(element => ({
                ...element,
                nombre_ciclo: ensayosMap.get(element.id_ensayo) || 'No encontrado',
            }));

            this.loading = false;
        },

        async getDatosEnsayos() {
            const payload = { path: 'ciclos/get-todos-ensayos', params: {} };
            const res = await this.getData(payload);
            
            // Ordenamos por fecha de una vez para facilitar el cálculo
            let todos = res.results.sort((a, b) => new Date(a.fechahora_ensayo) - new Date(b.fechahora_ensayo));
            
            // Diccionario para llevar la cuenta por "día operativo" (que empieza a las 06:00)
            const contadoresPorDia = {};

            todos.forEach(element => {
                const fechaEnsayo = new Date(element.fechahora_ensayo);
                const horas = fechaEnsayo.getHours();
                
                // Lógica de "Día Operativo": si es antes de las 6am, pertenece al día anterior
                let fechaOperativa = new Date(fechaEnsayo);
                if (horas < 6) {
                    fechaOperativa.setDate(fechaOperativa.getDate() - 1);
                }

                // Formato YYYY/MM/DD para el prefijo
                const prefijo = `${fechaOperativa.getFullYear()}/${(fechaOperativa.getMonth() + 1).toString().padStart(2, '0')}/${fechaOperativa.getDate().toString().padStart(2, '0')}`;

                // Incrementar contador para ese prefijo
                if (!contadoresPorDia[prefijo]) {
                    contadoresPorDia[prefijo] = 1;
                } else {
                    contadoresPorDia[prefijo]++;
                }

                // Asignar nombre solo si está en la lista de IDs modificados para ahorrar memoria
                if (this.ids.includes(`${element.id_ensayo}`)) {
                    element['nombre'] = `${prefijo}-${contadoresPorDia[prefijo]}`;
                }
            });

            this.datos = todos;
        },
        diaASiguiente(ano, mes, dia){
            let mes_mas_uno = parseInt(mes) - 1 //Internamente empieza desde 0
            const manana = new Date(ano, mes_mas_uno.toString(), dia)
            manana.setDate(manana.getDate() + 1)
            return this.formatDate(manana)
        },
        formatDate(date) { // yyyy-mm-dd
            return [
            date.getFullYear(),
            this.padTo2Digits(date.getMonth() + 1),
            this.padTo2Digits(date.getDate()),
            ].join('-');
        },
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },
        anadirNombreEnsayo(item){
            let salida = 'Obteniendo..'
            this.datos.filter(d =>{
                if(item.id_ensayo == d.id_ensayo){
                    // console.log('Nombre del ciclo: ' + d['nombre']);
                    salida = d['nombre']
                }
            })
            return salida
        },
    },
    async created() {
        await this.getModificaciones()
    },
}
</script>

<style>
    
</style>